

import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import "./JobDetails.css";
import JobLinksSection from "./JobLinksSection";
import JobDetailTables from "./JobDetailTables";
import JobInfoTables from "./JobInfoTables";

const JobDetails = () => {
  const { slug } = useParams(); // ✅ Slug from URL
  const [job, setJob] = useState(null);

  useEffect(() => {
    const API_URL = process.env.REACT_APP_NODE_BACKEND_API_URL;

    fetch(`${API_URL}/jobs/slug/${slug}`) // ✅ Fetch by slug
      .then((res) => res.json())
      .then((data) => setJob(data))
      .catch((err) => console.error("Error:", err));
  }, [slug]);

  if (!job) {
    return (
      <div className="loading-container">
        <div className="spinner"></div>
      </div>
    );
  }

  return (
    <div className="job-details-container">
      {/* Logo and Location */}
      {(job.companyLogo || job.location) && (
        <div style={{ textAlign: "center", marginBottom: "1rem" }}>
          {job.companyLogo && (
            <img
              src={job.companyLogo}
              alt="Company Logo"
              style={{ maxHeight: "80px", marginBottom: "0.5rem" }}
            />
          )}
          {job.location && (
            <div style={{ fontSize: "1.1rem", fontWeight: "bold", color: "#444" }}>
              📍 {job.location}
            </div>
          )}
        </div>
      )}

      {/* Job Title */}
      <h2 className="job-title">{job.JobTitle}</h2>
      <hr className="hr-text" />


          {/* Last updated date */}
          {job.updatedAt && (
            <p
              style={{
                fontSize: "0.9rem",
                textAlign: "right",
                marginTop: "-0.5rem",
                marginBottom: "-0.5rem",
              }}
            >
              <span style={{ color: "#d32f2f", fontWeight: "500" }}>
                Last update on:
              </span>{" "}
              <span style={{ color: "#d32f2f", fontWeight: "700" }}>
                {new Date(job.updatedAt).toLocaleDateString("en-IN", {
                  day: "2-digit",
                  month: "long",
                  year: "numeric",
                })}
              </span>
            </p>
          )}


      {/* About Job */}
      {job.AboutJob && (
        <div className="about-post-container">
          <span dangerouslySetInnerHTML={{ __html: job.AboutJob }} />
        </div>
      )}

      {/* Info Tables (dates, fees, posts, age) */}
      <JobInfoTables job={job} />

      <JobDetailTables job={job} />

      <JobLinksSection job={job} />

      {/* Optional Detail Tables (vacancyTable etc) */}
      {/* If using: <JobDetailTables job={job} /> */}

      {/* Action Section */}
      {(job.applyUrl || job.websiteUrl || job.pdfUrl?.length || job.admitCard?.length || job.result?.length) && (
        <div className="job-action-section">
          {(job.applyUrl || job.websiteUrl) && (
            <div className="job-action-group">
              <h5>🔗 Important Links</h5>
              <table className="job-action-table">
                <tbody>
                  {job.applyUrl && (
                    <tr>
                      <td>🚀 Apply Now</td>
                      <td>
                        <a
                          href={job.applyUrl}
                          className="btn btn-primary"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Apply
                        </a>
                      </td>
                    </tr>
                  )}
                  {job.websiteUrl && (
                    <tr>
                      <td>🌐 Official Website</td>
                      <td>
                        <a
                          href={job.websiteUrl}
                          className="btn btn-purple"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Visit
                        </a>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          )}

          {job.pdfUrl?.length > 0 && (
            <div className="job-action-group">
              <h5>📄 Notification PDFs</h5>
              <table className="job-action-table">
                <tbody>
                  {job.pdfUrl.map((card, index) => (
                    <tr key={index}>
                      <td>{card.label}</td>
                      <td>
                        <a
                          href={card.value}
                          className="btn btn-warning"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Download
                        </a>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          {job.admitCard?.length > 0 && (
            <div className="job-action-group">
              <h5>🎫 Admit Cards</h5>
              <table className="job-action-table">
                <tbody>
                  {job.admitCard.map((card, index) => (
                    <tr key={index}>
                      <td>{card.label} Admit Card</td>
                      <td>
                        <a
                          href={card.value}
                          className="btn btn-warning"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Download
                        </a>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          {job.result?.length > 0 && (
            <div className="job-action-group">
              <h5>📢 Results</h5>
              <table className="job-action-table">
                <tbody>
                  {job.result.map((res, index) => (
                    <tr key={index}>
                      <td>{res.label} Result</td>
                      <td>
                        <a
                          href={res.value}
                          className="btn btn-dark"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Check
                        </a>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}

      {/* Back Button */}
      <div style={{ textAlign: "center", marginTop: "2rem" }}>
        <Link to="/" className="back-btn">
          ← Back to Home
        </Link>
      </div>
    </div>
  );
};

export default JobDetails;
